import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Content from '../../../layout/Content';
import { ITINERARY_SUPPLIER_FOOD_REPORT_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import { ENTER_DATA_TO_SHOW_DATA } from '../../../../config/messages';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import Alert from '../../../common/informative/Alert';
import ItinerarySupplierFoodReportForm from './ItinerarySupplierFoodReportForm';
import ItinerarySupplierFoodReportResult from './ItinerarySupplierFoodReportResult';
import {
  clearItinerarySupplierFoodReport,
  getItinerarySupplierFoodReport,
  getItinerarySupplierFoodReportExcel,
} from '../../../../actions/food/ItinerarySupplierFood';

const ItinerarySupplierFoodReport = ({
  breadcrumbs,
  loading,
  dispatchGetItinerarySupplierFoodReport,
  dispatchGetItinerarySupplierFoodReportExcel,
  dispatchClearItinerarySupplierFoodReport,
}) => {
  const [searchValues, setSearchValues] = useState(null);

  const buildSearchValues = (formValues) => ({
    supplierId: formValues.supplierId ? formValues.supplierId.value : null,
    from: tzNormalizeDate({
      date: formValues.fromDateString,
      format: INT_DATE_FORMAT,
    }),
    to: tzNormalizeDate({
      date: formValues.toDateString,
      format: INT_DATE_FORMAT,
    }),
  });

  const onSearch = (values) => {
    dispatchClearItinerarySupplierFoodReport();
    dispatchGetItinerarySupplierFoodReport(values);
  };

  const onSubmitSearch = (formValues) => {
    const newSearchValues = buildSearchValues(formValues);

    setSearchValues(newSearchValues);
    onSearch(newSearchValues);
  };

  const onDownloadExcel = (formValues) => {
    const newSearchValues = buildSearchValues(formValues);

    dispatchGetItinerarySupplierFoodReportExcel(newSearchValues);
  };

  let table = <Alert type="info" message={ENTER_DATA_TO_SHOW_DATA} />;
  if (searchValues) table = <ItinerarySupplierFoodReportResult />;

  const content = (
    <>
      <ItinerarySupplierFoodReportForm
        onSubmit={onSubmitSearch}
        loading={loading}
        onDownloadExcel={onDownloadExcel}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
      />
      <div className="mt-3">{table}</div>
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Reporte de Alimentación de Itinerarios por Proveedor"
      content={content}
    />
  );
};

ItinerarySupplierFoodReport.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  dispatchGetItinerarySupplierFoodReport: PropTypes.func.isRequired,
  dispatchGetItinerarySupplierFoodReportExcel: PropTypes.func.isRequired,
  dispatchClearItinerarySupplierFoodReport: PropTypes.func.isRequired,
};

const mapStateToProps = ({ FoodUnit }) => ({
  loading: FoodUnit.ItinerarySupplierFood.getIn(['report', 'loading']),

  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reporte de Alimentación de Itinerarios por Proveedor',
      href: ITINERARY_SUPPLIER_FOOD_REPORT_PATH,
    },
  ],
});

ItinerarySupplierFoodReport.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetItinerarySupplierFoodReport: getItinerarySupplierFoodReport,
  dispatchGetItinerarySupplierFoodReportExcel:
    getItinerarySupplierFoodReportExcel,
  dispatchClearItinerarySupplierFoodReport: clearItinerarySupplierFoodReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItinerarySupplierFoodReport);
